import { ValidateJSModel } from 'forms/shared/types';
import { hasYesOrNo } from 'models/validate';
import { LegalInvestigationsForeignItemModel } from '../types';

export const legalInvestigationsForeignItemValidator: ValidateJSModel<LegalInvestigationsForeignItemModel> = {
  ForeignGovernment: { hasValue: true, country: { excludeUnitedStates: true } },
  Granted: { presence: true, hasValue: { validator: hasYesOrNo } },
};
